import React, { useState, useEffect,useRef  } from "react";

import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Modal, Popconfirm, message } from "antd"; // 新增导入需要的组件
import FlowDesign from "../FlowDesign";
import * as service from "@/services/jobs";
const { clearAllJobs: clearAll } = service;

const Component = () => {
  const flowDesignRef = useRef<any>(null);
  const [showEdit, setShowEdit] = useState(false); // 控制弹窗显示隐藏
  const [isHasJob, setIsHasJob] = useState(false); // 标记是否有任务
  const { state, actions } = useAppContext();
  const { curFlow, curProject } = state;
  // console.log("curFlow.job_count", curFlow.job_count);
  const location = useLocation();
  const [allowUpDiagrams,setAllowUpDiagrams] = useState(null);
  const [action, setAction] = useState<"deleteDiagram"|"handleData"|"saveDiagram"| null>(null);
  const handleActionDone = () => setAction(null);
  const [flowReadonly,setFlowReadonly] = useState(true);
  const [onEditSuccessVariable,setOnEditSuccessVariable] = useState<number>(0);

  useEffect(() => {
    actions.loadData();
    // 执行数据加载逻辑
  }, [location.search]);
  // ========== 修改点2：初始化路由跳转和参数获取 ==========
  const navigate = useNavigate(); // 路由跳转方法
  const params = useParams(); // 获取路由路径参数（k/f）
  const projectId = params.k; // 对应/project/:k/flow/:f/design中的k
  const flowId = params.f;   // 对应/project/:k/flow/:f/design中的f
  // ========== 修改点2结束 ==========

  const goToViewParams = () => 
  {
    //调用保存函数
    setAction("saveDiagram");

    // // 校验参数，避免跳转失败
    // if (projectId && flowId) {
    //   // 跳转到新的参数查看页面路由（自定义路径，建议和现有格式统一）
    //   navigate(`/project/${projectId}/flow/${flowId}/params`);
    // } else {
    //   console.warn("缺少项目ID或流程ID，无法跳转到参数查看页面");
    //   // 可选：添加用户友好提示
    //   // message.warning("缺少必要参数，无法查看参数！");
    // }
  };
  
  const goToTasks = () => {
    // 校验参数，避免跳转失败
    if (projectId && flowId) 
    {
      //调用提交函数
      setAction("handleData");
      setAllowUpDiagrams(true);
      // navigate(`/project/${projectId}/flow/${flowId}/task`);
    } 
    else 
    {
      console.warn("缺少项目ID或流程ID，无法跳转到参数查看页面");
      // 可选：添加用户友好提示
      // message.warning("缺少必要参数，无法查看参数！");
    }
  };



  return (
    <ReactFlowProvider>
      {state.curFlow && state.curProject && state.projectList ? (
        <>
          <PageTop
            mainContent={
              <div className="settingSelectorArea">
                <PageSeletor />
              </div>
            }
          />
          <div style={{ display: "flex", flexDirection: "column" }} className="mainContent">
            {/* <div>流程数据页</div> */}

            {/* <div style={{display: "flex", flexDirection: "column",position:"absolute",bottom:flowReadonly?40:200,right:40,zIndex:1000}}>
              <Button type="primary" onClick={goToViewParams} style={{borderRadius:100,width:70,height:70,marginBottom:20}}>
                编辑参数
              </Button>
              {!(allowUpDiagrams===null?(curFlow.job_count>0?false:true):allowUpDiagrams) ? (
                // 有任务时显示激活编辑按钮 + 弹窗
                <>
                  <Button
                    style={{borderRadius:100,width:70,height:70}}
                    type="primary"
                    onClick={() => setShowEdit(true)}
                  >
                    激活编辑
                  </Button>
                  <Modal
                    title="注意"
                    open={showEdit}
                    footer={[
                      <Button key="cancel" onClick={() => setShowEdit(false)}>
                        取消
                      </Button>,
                      <Popconfirm
                        title="确定清空已有计算任务？"
                        onConfirm={async (e) => {
                          e.stopPropagation();
                          setAllowUpDiagrams(true);
                          setAction("deleteDiagram")
                          setShowEdit(false);

                          try {
                            const res = await clearAll(curFlow.id);
                            if (res.status === 200) {
                              setIsHasJob(false);
                              message.success("清空成功");
                              setShowEdit(false);
                            }
                          } catch (error) {
                            message.error("清空失败，请重试");
                            console.error("清空任务失败：", error);
                          }
                        }}
                        okText="是"
                        cancelText="否"
                      >
                        <Button key="confirm" type="primary">
                          确定
                        </Button>
                      </Popconfirm>,
                    ]}
                    onCancel={() => setShowEdit(false)} // 点击弹窗外部关闭
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 10,
                      }}
                    >
                      需要清空所有计算任务才能进行流程修改，是否清空已有计算任务？
                    </div>
                  </Modal>
                </>
              ) : (
                // 无任务时显示原提交按钮
                <Button
                  style={{borderRadius:100,width:70,height:70}}
                  type="primary"
                  onClick={goToTasks}
                >
                  提交
                </Button>
              )}
            </div> */}
            
            <FlowDesign
              allowUpDiagrams={allowUpDiagrams===null?(curFlow.job_count>0?false:true):allowUpDiagrams}
              action={action}
              onActionDone={handleActionDone}
              onReadonlyChange={setFlowReadonly}
              setAllowUpDiagrams={(newAllowUpDiagrams)=>{
                setAllowUpDiagrams(newAllowUpDiagrams);}}
              setShowEdit={(newShowEdit)=>{setShowEdit(newShowEdit);}}
              onEditSuccessVariable={onEditSuccessVariable}
            />
          </div>

          <Modal
            title="注意"
            open={showEdit}
            footer={[
              <Button key="cancel" onClick={() => setShowEdit(false)}>
                取消
              </Button>,
              <Popconfirm
                title="确定清空已有计算任务？"
                onConfirm={async (e) => {
                  e.stopPropagation();
                  setAllowUpDiagrams(true);
                  setAction("deleteDiagram")
                  setShowEdit(false);

                  try {
                    const res = await clearAll(curFlow.id);
                    if (res.status === 200) {
                      setIsHasJob(false);
                      message.success("清空成功");
                      setShowEdit(false);
                      setOnEditSuccessVariable(onEditSuccessVariable+1);
                    }
                  } catch (error) {
                    message.error("清空失败，请重试");
                    console.error("清空任务失败：", error);
                  }
                }}
                okText="是"
                cancelText="否"
              >
                <Button key="confirm" type="primary">
                  确定
                </Button>
              </Popconfirm>,
            ]}
            onCancel={() => setShowEdit(false)} // 点击弹窗外部关闭
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 10,
              }}
            >
              需要清空所有计算任务才能进行流程修改，是否清空已有计算任务？
            </div>
          </Modal>

        </>
      ) : null}
    </ReactFlowProvider>
  );
};

export default Component;
